import axios from 'axios';

/** Full API base including `/api`, e.g. https://myapp.vercel.app/api (optional override). */
const API_BASE_RAW = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

function defaultSameOriginBase() {
  if (typeof window === 'undefined' || !window.location?.origin) {
    return '/api';
  }
  return `${window.location.origin}/api`;
}

const apiClient = axios.create({
  baseURL: API_BASE_RAW || (BACKEND_URL ? `${BACKEND_URL}/api` : defaultSameOriginBase()),
  headers: {
    Accept: 'application/json',
  },
});

// Interceptors for logging/error handling
apiClient.interceptors.response.use(
  response => response,
  error => {
    const d = error.response?.data;
    console.error('API Error:', d ?? error.message, d && typeof d === 'object' ? JSON.stringify(d) : '');
    return Promise.reject(error);
  }
);

export default apiClient;
